var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { jsx } from "react/jsx-runtime";
import "../SearchDropdown/index.js";
import { Field } from "./Field.js";
import ___default from "lodash";
import { SearchDropdown } from "../SearchDropdown/SearchDropdown.js";
class SearchDropdownField extends Field {
  constructor() {
    super(...arguments);
    __publicField(this, "children", (fieldProps) => {
      const { meta, field, form } = fieldProps;
      return /* @__PURE__ */ jsx(
        SearchDropdown,
        __spreadProps(__spreadValues(__spreadValues({}, this.props), field), {
          selectedKey: field.value,
          onBlur: () => form.setFieldTouched(field.name, true),
          onChange: this._handleChange(fieldProps),
          errorMessage: meta.touched && meta.error || ""
        })
      );
    });
    __publicField(this, "_handleChange", (props) => {
      return (event, option, index, value) => {
        if (!this.props.multiSelect) {
          const value2 = !!option && option.key !== void 0 ? option.key : props.meta.initialValue;
          props.form.setFieldValue(props.field.name, value2);
        } else {
          if (event.type === "change") {
            if (option == null ? void 0 : option.key) {
              const values = ___default.get(props.form.values, props.field.name);
              if (!!values) {
                if (option.selected) {
                  props.form.setFieldValue(props.field.name, [...values, option.key]);
                } else {
                  const index2 = ___default.indexOf(values, option.key);
                  if (index2 !== -1) {
                    props.form.setFieldValue(props.field.name, [...values.slice(0, index2), ...values.slice(index2 + 1)]);
                  }
                }
              } else {
                if (option.selected) {
                  props.form.setFieldValue(props.field.name, [option.key]);
                }
              }
            }
          }
        }
        if (!!(option == null ? void 0 : option.key)) {
          this.props.onChange && this.props.onChange(event, option, index);
        }
      };
    });
  }
}
export {
  SearchDropdownField
};
//# sourceMappingURL=SearchDropdownField.js.map
